import { ChangeDetectorRef, Component } from '@angular/core';
import { LanguageService } from '../../services/language.service';
import { PopularDestinationService } from './popular-destination.service';
import { PopularDestinationCategoryService } from '../popular-destinations-category/popular-destination-category.service';
import {PopularDestinationRequest} from "./popular-destination.model";

@Component({
  selector: 'app-popular-destinations',
  standalone: false,
  templateUrl: './popular-destinations.component.html',
  styleUrl: './popular-destinations.component.css'
})
export class PopularDestinationsComponent {

  successMessage = '';
  errorMessage = '';

  languages: any[] = [];

  popularDestination: any[] = [];
  filteredPopularDestination: any[] = [];

  currentPage = 1;
  pageSize = 5;

  activeTab = 'all';
  activeTabPopup = 1;
  searchText = '';

  isModalOpen = false;

  isEnableSave: boolean = false;
  isEnableUpdate: boolean = false;
  isEnableDelete: boolean = false;

  popularDestinationId: number = 0;
  image: File | null = null;
  isPublish: boolean = false;
  popularDestinationCategoryId: number = 0;
  parentCategoryId: number | null = null;
  subCategoryId: number | null = null;
  nameKh: string = '';
  nameEn: string = '';
  linkKh: string = '';
  linkEn: string = '';

  categories: any[] = [];
  mergedCategories: any[] = [];
  selectedCategoryId: number | null = null;

  constructor(
    private popularDestinationService: PopularDestinationService,
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef,
    private popularDestinationCategoryService: PopularDestinationCategoryService
  ) { }

  ngOnInit(): void {
    this.loadLanguages();
    this.loadPopularDestination("");
    this.loadCategories();
  }

  loadCategories() {
    this.popularDestinationCategoryService
      .getAllPopularDestinationCategories()
      .subscribe((res: any) => {

        // Raw data
        this.categories = res.data;

        // Merge KH + EN
        this.mergeCategories();

      });
  }

  mergeCategories() {
    const grouped: { [key: number]: any } = {};

    this.categories.forEach(c => {
      if (!grouped[c.popularDestinationCategoryId]) {
        grouped[c.popularDestinationCategoryId] = {
          categoryId: c.popularDestinationCategoryId,
          parentCategoryId: c.parentCategoryId ?? null,
          kh: '',
          en: '',
          parentKh: '',
          parentEn: '',
          isEnabled: c.isEnabled
        };
      }

      if (c.languageCode === 'kh') {
        grouped[c.popularDestinationCategoryId].kh = c.name;
        grouped[c.popularDestinationCategoryId].parentKh = c.parentName ?? '';
      }

      if (c.languageCode === 'en') {
        grouped[c.popularDestinationCategoryId].en = c.name;
        grouped[c.popularDestinationCategoryId].parentEn = c.parentName ?? '';
      }
    });

    this.mergedCategories = Object.values(grouped);

    if (this.popularDestinationCategoryId) {
      this.syncCategorySelection(this.popularDestinationCategoryId);
    }
  }

  getCategoryName(category: any): string {
    return [category.kh, category.en].filter(Boolean).join(' - ');
  }

  get parentCategories(): any[] {
    return this.mergedCategories.filter(category => !category.parentCategoryId);
  }

  get subCategories(): any[] {
    if (!this.parentCategoryId) {
      return [];
    }

    return this.mergedCategories.filter(category =>
      category.parentCategoryId === this.parentCategoryId
    );
  }

  onParentCategoryChange() {
    this.subCategoryId = null;
    this.popularDestinationCategoryId = this.parentCategoryId ?? 0;
  }

  onSubCategoryChange() {
    this.popularDestinationCategoryId = this.subCategoryId
      ?? this.parentCategoryId
      ?? 0;
  }

  syncCategorySelection(categoryId: number) {
    const category = this.mergedCategories.find(item => item.categoryId === categoryId);

    if (!category) {
      this.parentCategoryId = categoryId || null;
      this.subCategoryId = null;
      return;
    }

    if (category.parentCategoryId) {
      this.parentCategoryId = category.parentCategoryId;
      this.subCategoryId = category.categoryId;
    } else {
      this.parentCategoryId = category.categoryId;
      this.subCategoryId = null;
    }
  }

  loadLanguages() {

    this.languageService.getAll().subscribe((res: any) => {

      this.languages = res.data.sort(
        (a: any, b: any) => a.languageId - b.languageId
      );

      if (this.languages.length > 0) {
        this.setTab(this.languages[0].code);
      }

    });

  }

  loadPopularDestination(langCode: string) {

    this.popularDestinationService.getAllPopularDestination(langCode)
      .subscribe((res: any) => {

        const apiData: any[] = res.data || [];

        this.popularDestination = apiData
          .filter(item => item.translations && item.translations.length > 0)
          .flatMap(item =>
            item.translations.map((t: any) => ({
              popularDestinationId: item.popularDestinationId,
              image: item.image,
              link: t.link,
              categoryId: item.categoryId,
              isPublish: item.isPublish,
              name: t.name,
              languageCode: t.languageCode,
              languageId: t.languageId,

              categoryName: t.categoryName
            }))
          );
        
          console.log(this.popularDestination);
        this.filterPopularDestination("kh");

      });

  }

  setTab(tab: string) {

    this.activeTab = tab;
    this.currentPage = 1;

    this.filterPopularDestination(tab);
  }


  filterPopularDestination(tab: string) {
    const keyword = this.searchText.trim().toLowerCase();
    this.currentPage = 1;

    this.filteredPopularDestination =
      this.popularDestination.filter(destination => {
        const matchesTab = destination.languageCode === tab;
        const matchesSearch = !keyword ||
          `${destination.name ?? ''} ${destination.categoryName ?? ''} ${destination.link ?? ''} ${destination.languageCode ?? ''}`
            .toLowerCase()
            .includes(keyword);

        return matchesTab && matchesSearch;
      });

  }


  get pagedDestination(): any[] {

  const start = (this.currentPage - 1) * this.pageSize;
  const end = start + this.pageSize;

  return this.filteredPopularDestination.slice(start, end);

}

  totalPages(): number {
    return Math.ceil(
      this.filteredPopularDestination.length / this.pageSize
    );
  }

  changePage(page: number) {
    this.currentPage = page;
  }


  setTabPopup(tab: number) {
    this.activeTabPopup = tab;
  }


  getLanguageCount(lang: string): number {

    return this.popularDestination.filter(
      r => r.languageCode === lang
    ).length;

  }

  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  visibleButtonControl(eventName: string) {

    this.isEnableSave = false;
    this.isEnableUpdate = false;
    this.isEnableDelete = false;

    if (eventName === 'Add') { this.isEnableSave = true }
    else if (eventName === 'Edit') { this.isEnableUpdate = true }
    else if (eventName === 'Delete') { this.isEnableDelete = true }

  }

  viewData(id: number, eventName: string) {

    this.visibleButtonControl(eventName);
    this.popularDestinationId = id;

    this.popularDestinationService.getPopularDestinationById(id,"").subscribe({
      next: (res) => {

        if (res.status === "success") {
          
          let data = res.data;

          this.popularDestinationId = data.popularDestinationId;
          this.popularDestinationCategoryId = data.categoryId;
          this.syncCategorySelection(data.categoryId);
          this.image = data.image;
          this.isPublish = data.isPublish;
          this.linkKh = '';
          this.linkEn = '';

          data.translations.forEach((item: any) => {
            if (item.languageCode === 'kh') {
              this.nameKh = item.name;
              this.linkKh = item.link;
              // this.isEnabled = item.isEnabled;
            } else if (item.languageCode === 'en') {
              this.nameEn = item.name;
              this.linkEn = item.link;
              // this.isEnabled = item.isEnabled;
            }
          });

          this.openModal();
        } else {
          this.errorMessage = res.message;
        }

        setTimeout(() => {
          this.clearMsg();
          this.cdr.detectChanges();
        }, 3000);

      },
      error: (err) => {

        this.errorMessage = "Failed to create language";

        setTimeout(() => {
          this.clearMsg();
          this.cdr.detectChanges();
        }, 3000);

      }
    });

  }

  clearMsg() {
    this.successMessage = '';
    this.errorMessage = '';
  }

  resetForm() {
    this.popularDestinationId = 0;
    this.popularDestinationCategoryId = 0;
    this.parentCategoryId = null;
    this.subCategoryId = null;
    this.nameKh = '';
    this.nameEn = '';
    this.linkKh = '';
    this.linkEn = '';
    this.image = null;
    this.isPublish = false;
  }

  addNew() {

    this.visibleButtonControl('Add');
    this.resetForm();
    this.openModal();

  }

  getRequest(popularDestinationId?: number): PopularDestinationRequest {
    return {
      image: this.image instanceof File ? this.image : undefined,
      isPublish: this.isPublish,
      data: {
        popularDestinationId: popularDestinationId, // optional for update
        popularDestinationCategoryId: this.subCategoryId
          ?? this.parentCategoryId
          ?? this.popularDestinationCategoryId
          ?? 0,

        translations: [
          {
            languageId: 1, // Khmer
            name: this.nameKh ?? '',
            link: this.linkKh ?? ''
          },
          {
            languageId: 2, // English
            name: this.nameEn ?? '',
            link: this.linkEn ?? ''
          }
        ]
      }
    };
  }

  onFileSelected(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      this.image = event.target.files[0];
    }
  }

  refreshData(status: string, message: string) {

    if (status === "success") {
      this.successMessage = message;
      this.closeModal();
      this.loadPopularDestination("");
      this.resetForm();
    } else {
      this.errorMessage = message;
    }

    setTimeout(() => {
      this.clearMsg();
      this.cdr.detectChanges();
    }, 3000);

  }

  exceptionData(message: string) {
    this.errorMessage = message;
    setTimeout(() => {
      this.clearMsg();
      this.cdr.detectChanges();
    }, 3000);
  }

  save() {

    const request = this.getRequest(0);
    this.clearMsg();

    this.popularDestinationService.create(request).subscribe({
      next: (res) => {
        this.refreshData(res.status, res.message);
      },
      error: (err) => {
        this.exceptionData(err);
      }
    });

  }

  update() {

    this.clearMsg();

    const request = this.getRequest(this.popularDestinationId);

    this.popularDestinationService.update(this.popularDestinationId,request).subscribe({

      next: (res) => {
        this.refreshData(res.status, res.message);
      },
      error: (err) => {
        this.exceptionData(err);
      }

    });

  }

  delete() {

    if (!confirm("Are you sure you want to delete ?")) {
      return;
    }

    this.popularDestinationService.delete(this.popularDestinationId).subscribe({
      next: (res) => {
        this.refreshData(res.status, res.message);
      },
      error: (err) => {
        this.exceptionData(err);
      }
    });

  }

}
